// CallOverlay.jsx
import React from "react";
import CallRoom from "../components/CallRoom";
import { useRtcStore } from "../stores/rtcStore";

export default function CallOverlay() {
    const activeCall = useRtcStore((s) => s.activeCall);
    const clearActiveCall = useRtcStore((s) => s.clearActiveCall);
    const overlayOpen = useRtcStore((s) => s.overlayOpen);
    const closeOverlay = useRtcStore((s) => s.closeOverlay);
    // if (!activeCall) return null;
    if (!overlayOpen || !activeCall) return null;


    return (
        <div style={{
            position: "fixed", right: 12, bottom: 12, width: 420, height: 520,
            background: "#fff", borderRadius: 14, boxShadow: "0 10px 30px rgba(0,0,0,.25)",
            overflow: "hidden", zIndex: 9999
        }}>
            <div style={{ padding: 8, borderBottom: "1px solid #eee", display: "flex", justifyContent: "space-between" }}>
                <div>通話</div>
                <button onClick={clearActiveCall}>關閉</button>
            </div>
            <div style={{ height: "calc(100% - 42px)" }}>
                <CallRoom
                    kind={activeCall.kind}
                    id={activeCall.id}
                    mode={"audio"}
                    token={activeCall.token}
                    wsUrl={activeCall.wsUrl}
                    roomName={activeCall.roomName}
                />
            </div>
        </div>
    );
}
